import { PERMISSIONS } from '@/generated/permissions'

export const adminRoutes = [
  {
    component: () => import('@/domains/admin/pages/UserRolesPage.vue'),
    meta: { anyPerm: [PERMISSIONS.ADMIN_USERS_MANAGE], requiresAuth: true },
    name: 'admin-user-roles',
    path: '/admin/user-roles',
  },
  {
    component: () => import('@/domains/admin/pages/users/DetailPage.vue'),
    meta: { anyPerm: [PERMISSIONS.ADMIN_USERS_MANAGE], requiresAuth: true },
    name: 'admin-user-detail',
    path: '/admin/users/:email',
  },
  {
    component: () =>
      import('@/domains/admin/pages/ContractorApprovalsPage.vue'),
    meta: { anyPerm: [PERMISSIONS.CONTRACTOR_APPROVE], requiresAuth: true },
    name: 'admin-contractor-approvals',
    path: '/admin/contractor-approvals',
  },
  {
    component: () => import('@/domains/admin/pages/AuditLogsPage.vue'),
    meta: { anyPerm: [PERMISSIONS.AUDIT_READ], requiresAuth: true },
    name: 'admin-audit-logs',
    path: '/admin/audit-logs',
  },
  {
    component: () => import('@/domains/admin/pages/SettingsPage.vue'),
    meta: {
      anyPerm: [PERMISSIONS.SETTINGS_NOTIFICATIONS_MANAGE],
      requiresAuth: true,
    },
    name: 'admin-settings',
    path: '/admin/settings',
  },
]
